module.exports = {
  "calendar": "Calend\xE1rio",
  "day": "dia",
  "dayPeriod": "am/pm",
  "endDate": "Data de T\xE9rmino",
  "era": "era",
  "hour": "hora",
  "minute": "minuto",
  "month": "m\xEAs",
  "second": "segundo",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Data selecionada: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Intervalo selecionado: ".concat(args.startDate, " a ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Hora selecionada: ".concat(args.time);
  },
  "startDate": "Data de In\xEDcio",
  "timeZoneName": "fuso hor\xE1rio",
  "weekday": "dia da semana",
  "year": "ano"
};